<template>
  <div class="supplier-from">
      <div class="pd-15">
        <el-form :model="form" :rules="formRules" ref="form" label-width="92px">
          <div class="form-item-wrap">
            <el-form-item label="供应商名字" prop="supplierName">
              <el-input v-model="form.supplierName" :disabled="subjectCreate" size="mini" style="width:282px;" @input="inputSupplierName"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="form.supplierState" placeholder="请选择" size="mini" style="width:282px">
                <el-option
                  v-for="(item, index) in stateList" 
                  :key="index"
                  :label="item.label"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="联系人">
              <input-util :form="form" :customize="false" width="282px" size="mini" k="contacts" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
            <el-form-item label="联系电话" prop="tele">
              <input-util :form="form" :customize="false" width="282px" size="mini" k="tele" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="银行账号" prop="bankAccount">
              <input-util :form="form" :customize="false" width="282px" size="mini" k="bankAccount" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
            <el-form-item label="开户行">
              <input-util :form="form" :customize="false" width="282px" size="mini" k="bankName" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item class="d-ib" label="分类">
              <el-input size="mini" v-model="form.classification" style="width:282px"></el-input>
            </el-form-item>
            <el-form-item class="d-ib" label="地区">
              <area-util :form="form" width="282px"></area-util>
            </el-form-item>
          </div>
          <div>
            <el-form-item class="d-ib" label="期末调汇">
              <el-radio-group size="mini" v-model="form.endingExchange" style="width:282px">
                <el-radio size="mini" :label="1">是</el-radio>
                <el-radio size="mini" :label="0">否</el-radio>
              </el-radio-group>              
            </el-form-item>
            <el-form-item class="d-ib" label="币别">
              <el-select v-model="form.currencies" size="mini">
                <el-option v-for="(item, index) in currencyList" :key="item.currencyId" :value="item.currencyId" :label="item.currencyName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="邮箱" prop="email">
              <input-util :form="form" :customize="false" width="648px" size="mini" k="email" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="税务登记号" prop="taxId">
              <input-util :form="form" :customize="false" width="648px" size="mini" k="taxId" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="现居住地">
              <input-util :form="form" :customize="false" width="648px" size="mini" k="nowAddr" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="form-item-wrap">
            <el-form-item label="备注">
              <input-util :form="form" :customize="false" width="648px" size="mini" k="remark" :state="state" @stateCB="changeState"></input-util>
            </el-form-item>
          </div>
          <div class="assist-top-title">
            <p>是否同时新增科目：</p>
          </div>
          <div>
            <el-table ref="supplierAssist" :data="assistList" style="width:728px" tooltip-effect="dark" @selection-change="handleSelectionChange" border>
              <el-table-column type="selection" :selectable="selectable" width="55"></el-table-column>
              <el-table-column prop="name" label="科目">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.name + handleCustomerName()}}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="assist-bottom-title">
            <p>未勾选的科目在生成自动凭证时, 如需使用, 会自动新增</p>
          </div>
          <div class="ta-r">
            <el-button type="primary" size="mini" v-if="!form.supplierId && !subjectCreate && saveAddAble" @click="submit('form',false)">保存并新增</el-button>
            <el-button name="py-save-40" type="primary" size="mini" @click="submit('form',true)">保存并退出</el-button>
            <el-button @click="closeBox()" size="mini">取消</el-button>
          </div>
        </el-form>
      </div>
  </div>
</template>
<script>
const teleReg = /^(\d{3,4}-)\d{7,8}$/
const phoneReg = /^1[345678]\d{9}$/
const emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
const numberReg = /^[+]{0,1}(\d+)$/ 
import {
  Req_GetCurrencyList,
  Req_GetAssistList,
  Req_SubmitSupplier,
  Req_CheckIsExist
} from '@/request/supplier'
import SelectUtil from '@/components/Util/SelectUtil'
import AreaUtil from '@/components/Util/AreaUtil'
import InputUtil from '@/components/Util/InputUtil'
import {
  deepClone
} from '@/util'
let supplierNameTimer
export default {
  data() {
    const checkTele = (rule, value, callback) => {
      if(!value) return callback()
      if(!teleReg.test(value) && value){
        if(!phoneReg.test(value)){
          callback(new Error('请检查位数或固话请填写:区号-电话号码'))
        }
      }
      callback()
    }
    const checkBankAccount = (rule, value, callback) => {
      if(value){
        if(!numberReg.test(value)){
          return callback(new Error('请填写只包含数字的账号'))
        }
      }
      callback()
    }
    const checkEmail = (rule, value, callback) => {
      if(value){
        if(!emailReg.test(value)){
          return callback(new Error('请输入正确的邮箱,格式为xx@xx.xx'))
        }
      }
      callback()
    }
    const checkTaxId = (rule, value, callback) => {
      if(value){
        const taxLength = value.split('').length
        if(taxLength === 20 || taxLength === 18 || taxLength === 15) return callback()
        
        return callback('税务登记号的长度为15、18、20位其中一位')
      }
      callback()
    }
    return {
      // formData:{},
      state:{},
      boxStatus:false,
      assistList:[],
      assistSelection:[],
      selectAssist:[],
      formRules:{
        supplierName:[
          { required: true, message: '供应商名称不能为空', trigger: 'change' },
        ],
        tele:[
          {validator:checkTele, trigger:'change'}
        ],
        bankAccount:[
          {validator:checkBankAccount, trigger:'change'},
          {max:25, message:'长度在1到25位银行卡账号',trigger:'change'}
        ],
        email:[
          {validator:checkEmail, trigger:'change'}
        ],
        taxId:[
          {validator:checkTaxId, trigger:'change'}
        ]
      },
      stateList:[
        {type:1,label:'启用'},
        {type:0,label:'停用'}
      ],
      currencyList:[]
    }
  },
  props:{
    saveAddAble: {
      type: Boolean,
      default: true
    },
    form:{
      type:Object,
      required:true
    },
    // formStatus:{
    //   type:Boolean,
    //   default:false,
    //   required:true
    // },
    subjectCreate:{
      type:Boolean,
      default:false
    },
    subjectpName:{
      type:String,
    }
  },
  created() {
    this.showBox()
    this.getCurrency()
  },
  methods: {
    getCurrency(){
      Req_GetCurrencyList({
        customerId: this.$store.state.companyInfo.customerId
      }).then(res => {
        this.currencyList = res.finCustomerCurrencyDTOByOn
      }).catch(err => this.$catchErr(err))
    },
    handleCustomerName(){
      // console.log(this.form.customerInnerName)
      if(this.form.classification){
        return ('-' + this.form.classification + '-' + this.form.supplierName)
      }else if(!this.form.classification && this.form.province){
        return ('-' + this.form.province + '-' + this.form.supplierName)
      }else{
        return ('-' + this.form.supplierName)
      }
    },
    showBox(){
      // this.initSupplierForm(this.form)
      if(this.subjectCreate || this.form.supplierId || this.form.supplierName){
        this.inputSupplierName(this.form.supplierName)
      }
    },
    inputSupplierName(val){
      clearTimeout(supplierNameTimer)
      if(val){
        supplierNameTimer = setTimeout(() => {
          this.getAssistList(val)
        }, 500);
      }else{
        this.assistList = []
      }
    },
    selectable(row,index){
      return true
    },
    getAssistList(name){
      Req_GetAssistList({
        name,
        type:20,
        customerId: this.$store.state.companyInfo.customerId
      }).then(res => {
        this.assistList = res
        this.$nextTick(function(){
          res.forEach((item,index) => {
            if(this.subjectCreate){
              if(item.name === this.subjectpName) this.$refs.supplierAssist.toggleRowSelection(this.assistList[index],true)
            }else if(item.required || item.isGen){
              this.$refs.supplierAssist.toggleRowSelection(this.assistList[index],true)
            }
          })
        })
      }).catch(err => this.$catchErr(err))
    },
    handleSelectionChange(val){
      this.assistSelection = val;
      const list = []
      val.forEach((item,index) => {
        const assist = {
          customerId: this.$store.state.companyInfo.customerId,
          pCode:item.code,
          name:this.form.supplierName,
          direction:item.direction,
          beanType:item.beanType,
          subjectId:item.subjectId
        }
        list.push(assist)
      });
      this.form.subjectBeanDTOList = list
      this.selectAssist = list
    },
    changeState(type){
      const state = deepClone(this.form)
      state[type] = !state[type]
      this.state = state
    },
    closeBox(){
      this.$emit('closeBox')
    },
    submitRequest(closeType){
      Req_SubmitSupplier({
        ...this.form,
        customerId: this.$store.state.companyInfo.customerId
      }).then(res => {
        this.$message.success(!this.form.supplierId ? '创建成功' : '修改成功')
        if(this.subjectCreate){
          this.$emit('createSubject',res.subjectBeanDTOList[0].beanId)
        }
        if(closeType){
          this.$emit('configSuccess',res)
          this.$emit('addSuccess')
        }else{
          this.$emit('configSuccess',res,closeType,true)
          this.$emit('addSuccess',closeType,true)
        }
      }).catch(err => this.$catchErr(err))
    },
    submit(formName,closeType){
      if(window.$request.state) return;
      if(this.assistSelection.length === 0) return this.$message.error('请至少选择一个科目')
      this.$refs[formName].validate((valid) => {
        if(valid){
          const checkParams = {
            name:this.form.supplierName,
            type:10,
            customerId: this.$store.state.companyInfo.customerId
          }
          Req_CheckIsExist(checkParams).then(res => {
            if(res.result){
              this.$confirm(`${res.message}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.submitRequest(closeType)
              })
            }else{
              this.submitRequest(closeType)
            }
          }).catch(err => this.$catchErr(err))
        }else{
          this.$message.error('请检查表单是否正确')
          return false
        }
      })
    },
  },
  watch: {
    form(nV){
      if(nV.supplierName){
        this.getAssistList(this.form.supplierName)
      }
    },
    formStatus(nV){
      this.boxStatus = nV
    }
  },
  components:{
    SelectUtil,
    AreaUtil,
    InputUtil
  }
}
</script>

<style lang="scss" scoped>
  .form-box /deep/ .el-dialog__body{
    padding: 0px;
  }
  .form-item-wrap{
    display: flex;
  }
  .assist-top-title{
    p{
      font-size: 16px;
      font-weight: bold;
      margin: 10px 0;
    }
  }
  .assist-bottom-title{
    p{
      font-size: 14px;
      margin: 10px 0;
      color: red;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Finance/SupplierForm.vue